export default {
    highcharts: {
        'reset-zoom-title': 'Reset zoom',

        'decimal-point': '.',
        'thousands-sep': ' ',

        Mon: 'Mon',
        Tue: 'Tue',
        Wed: 'Wed',
        Thu: 'Thu',
        Fri: 'Fri',
        Sat: 'Sat',
        Sun: 'Sun',
        Jan: 'Jan',

        January: 'January',
        Feb: 'Feb',
        February: 'February',
        Mar: 'Mar',
        March: 'March',
        Apr: 'Apr',
        April: 'April',
        May: 'May',
        Jun: 'Jun',
        June: 'June',
        Jul: 'Jul',
        July: 'July',
        Aug: 'Aug',
        August: 'August',
        Sep: 'Sep',
        September: 'September',
        Oct: 'Oct',
        October: 'October',
        Nov: 'Nov',
        November: 'November',
        Dec: 'Dec',
        December: 'December',
    },
    chartkit: {
        error: 'Error',

        'tooltip-point-format-size': 'Size',
        'tooltip-sum': 'Sum',
        'tooltip-rest': 'Rest',

        'error-incorrect-key-value-intro': 'Incorrect notation of an object passed to',
        'error-incorrect-key': ', object keys must be convertible to integer',
        'error-incorrect-value':
            ', object values must be a string or a function which returns a string',
        'label-palette-editor': 'Color palette editor',
        'label-load-from-file': 'Load from file',
    },
    'chartkit-table': {
        'message-no-data': 'No data',
        'paginator-rows': 'Rows',
    },
    'chartkit-ymap-legend': {
        'label-more': 'Show more {{count}}',
        'label-hide': 'Hide',
        'label-heatmap': 'Heatmap',
    },
};
